<template>
  <section class="find-vacancy-info">
    <div class="find-vacancy-info__content-wrap  container">
      <div class="find-vacancy-info__content container-inner">
        <h2 class="find-vacancy-info__title">
          {{ section.heading }}
        </h2>
        <div class="find-vacancy-info__main">
          <picture class="find-vacancy-info__img">
            <source v-if="section.image_mob_webp"
                    :srcset="section.image_mob_webp"
                    type="image/webp"
                    :media="`(max-width: ${WINDOW_SIZE_SM}px)`">
            <source v-if="section.image_mob"
                    :srcset="section.image_mob"
                    :media="`(max-width: ${WINDOW_SIZE_SM}px)`">
            <source :srcset="section.image_webp"
                    type="image/webp">
            <img :src="section.image"
                 alt="Що таке Jobian?">
          </picture>
          <div class="find-vacancy-info__text  text">
            <p>{{ section.text }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import {WINDOW_SIZE_SM} from '@/constants/windowSizes'

  export default {
    name: 'FindVacancyPageInfo',
    props: {
      section: Object
    },
    data() {
      return {
        WINDOW_SIZE_SM
      }
    }
  }
</script>

<style lang="less">

</style>
